import { getApps, initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

// Your Firebase config (use env vars in real projects)
const firebaseConfig = {
    apiKey: process.env.GATSBY_FIREBASE_APIKEY,
    authDomain: process.env.GATSBY_FIREBASE_AUTHDOMAIN,
    projectId: process.env.GATSBY_FIREBASE_PROJECTID,
    storageBucket: process.env.GATSBY_FIREBASE_STORAGEBUCKET,
    messagingSenderId: process.env.GATSBY_FIREBASE_MESSAGINGSENDERID,
    appId: process.env.GATSBY_FIREBASE_APPID,
};

let app;

export const initFirebase = () => {
    if (typeof window !== "undefined" && getApps().length === 0) {
        app = initializeApp(firebaseConfig);
    }
};

export const getFirebaseAuth = () => {
    initFirebase(); // Ensure initialized before calling getAuth
    return getAuth();
};
